module.exports = "<svg width=\"63px\" height=\"63px\" viewBox=\"0 0 63 63\" xmlns=\"http://www.w3.org/2000/svg\">\n  <title>Align Top</title>\n  <g fill=\"none\" fill-rule=\"evenodd\">\n    <path fill=\"#525151\" d=\"M0 0h63v63H0z\"/>\n    <g transform=\"translate(17 20)\" fill=\"#FFF\">\n      <rect x=\"6\" y=\"4\" width=\"7\" height=\"19\" rx=\"1\"/>\n      <rect x=\"16\" y=\"4\" width=\"7\" height=\"12\" rx=\"1\"/>\n      <rect width=\"28\" height=\"2\" rx=\"1\"/>\n    </g>\n  </g>\n</svg>"


//////////////////
// WEBPACK FOOTER
// ./src/icons/align/align-top.svg
// module id = 830
// module chunks = 0